import template from './views/extended-list.tpl.html';

export default {
    slug: 'contacts',
    exportSlugOverride: 'contacts',
    type: 'contact',
    title: 'Contacts',
    visible: [
        'customer_number',
        'full_name',
        'company_name',
        'email',
        'business_email',
    ],
    permanentFields: ['id', 'blacklist'],
    listview: 'ContactsListView',
    locales: ['common'],
    view: {
        mode: 'tableview'
    },
    templates: {
      customer_number: function(row) {
          return (row.blacklist) ? '<span class="text-red">' + row.customer_number + '</span>' : row.customer_number;
      },
      full_name: function(row) {
          return (row.blacklist) ? '<span class="text-red">' + row.full_name + '</span>' : row.full_name;
      },
      company_name: function(row) {
          return (row.blacklist) ? '<span class="text-red">' + row.company_name + '</span>' : row.company_name;
      }
    },
    extendedListView: true,
    extendedListViewTemplate: template,
    extendedListController: 'ContactExtendedListViewCtrl',
    copyColumns: [
        'code',
        'full_name',
        'email',
        'business_email',
        'preferred_email',
        'cc_email',
        'web',
        'business_web',
        'last_message_subject',
        'last_message_state_information',
        'last_invoice.address',
        'last_invoice.id',
        'last_invoice.invoice_number',
        'last_invoice.invoice_number_plain',
        'last_invoice.public_hash',
        'last_invoice_number'
    ],
    tooltipColumns: [
        'email',
        'business_email',
        'full_name',
        'company_name',
        'cc_email',
        'comment',
        'business_web',
        'web',
        'business_web',
        'blacklist_reason',
        'last_invoice.address',
        'last_invoice.subject',
        'last_invoice.text_1',
        'last_invoice.text_3',
        'last_invoice.text_3',
        'custom_1',
        'custom_2',
        'custom_3',
        'custom_4',
        'custom_5',
        'custom_6',
        'custom_7',
        'custom_8',
        'custom_9',
        'custom_10',
        'custom_11',
        'custom_12',
        'custom_13',
        'custom_14',
        'custom_15',
        'custom_16',
        'custom_17',
        'custom_18',
        'custom_19',
        'custom_10',
        'custom_21',
        'custom_22',
        'custom_23',
        'custom_24',
        'custom_25',
        'custom_26',
        'custom_27',
        'custom_28',
        'custom_29',
        'custom_30',
        'custom_31',
        'custom_32',
        'custom_33',
        'custom_34',
        'custom_35',
        'custom_36',
        'custom_37',
        'custom_38',
        'custom_39',
        'custom_40'
    ]
}



// WEBPACK FOOTER //
// ./src/app/store/contacts/state.js